module.exports = __webpack_public_path__ + "img/compass.86b76d87.svg";